import React from "react";
import { Form, Select } from "antd";
import "./FormItem.scss";

const { Option } = Select;

const FormItemSelect = ({
  label,
  name,
  placeholder = "Select",
  rules = [],
  options = [],
  disabled = false,
  allowClear = true,
  onChange
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
    >
      <Select
        placeholder={placeholder}
        disabled={disabled}
        allowClear={allowClear}
        onChange={onChange}
      >
        {options.map((item) => (
          <Option key={item.value} value={item.value}>
            {item.label}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default FormItemSelect;
